import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { filter, firstValueFrom, ReplaySubject } from 'rxjs';

let LastFetchTime = null;

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private readonly homesFacade = inject(HomesFacade);
  private readonly modulesFacade = inject(ModulesFacade);

  loaded$ = new ReplaySubject(1);

  outdoorModules = toSignal(this.modulesFacade.getModulesByType(['NAModule1']));

  async load(): Promise<void> {
    this.loaded$.next(false);

    await this.loadHomes();

    this.loaded$.next(true);
  }

  async loadHomes(): Promise<void> {
    await firstValueFrom(this.homesFacade.loadHomes({ gateway_types: '["NAMain"]' }));

    if (!LastFetchTime || new Date().getTime() - LastFetchTime.getTime() > 1000 * 60 * 5) {
      await firstValueFrom(this.homesFacade.getReadonlyDeviceState());

      const homes = await firstValueFrom(this.homesFacade.homes$.pipe(filter(homes => homes.length > 0)));
      const adminHomes = homes.filter(home => !home.mode);

      for (const home of adminHomes) {
        await firstValueFrom(this.homesFacade.loadHomeStatus({ home_id: home.id }));
      }

      LastFetchTime = new Date();
    }
  }
}
